// extracted by mini-css-extract-plugin
module.exports = {"Services":"Technologies_Services__2TyG6","select":"Technologies_select__2uUgP"};